export default __webpack_public_path__ + "static/media/birthday.93dd2bf5.png";